import React, { useEffect, useMemo, useState } from 'react';
import { object } from 'prop-types';
import { css } from '@emotion/css';

import { Input } from '@ajaibid/components';
import { SkeletonLoad } from 'Component/Skeleton';
import useAutoOrderAction from '../hooks/useAutoOrderAction/useAutoOrderAction';

const styOrderToggleButton = css`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 32px;
  border-radius: 4px;
`;

/**
 * @param {object} params
 * @param {import('@services/api/stock/order/auto/order').AutoOrder}  params.autoOrder
 * @returns
 */
function OrderToggleButton({ autoOrder }) {
  const { toggle } = useAutoOrderAction(autoOrder);
  const [isLoad, setIsLoad] = useState(false);

  const isActive = autoOrder.order_status === 'OPEN';
  const isExpired = autoOrder.order_status === 'EXPIRED';

  const onChange = async () => {
    setIsLoad(true);
    await toggle();
    setIsLoad(false);
  };

  return (
    <div className={styOrderToggleButton}>
      {isLoad && <SkeletonLoad height={20} width={50} />}
      {!isLoad && <Input.Toggle isChecked={isActive} onChange={onChange} />}
    </div>
  );
}

OrderToggleButton.propTypes = {
  autoOrder: object.isRequired,
};

export default OrderToggleButton;
